<template>
    <el-dialog  title="更新图片" :visible.sync="showBlock" :destroy-on-close="true"  width="600px" :before-close="handleClose">
           <UpLoadImng width="76" height="76" size="1" limit="5" rules="gif、png" @getUpload="getUpload" />
    </el-dialog>
</template>
<script>
  import {url} from '@/utils/config'
  import {postFun} from '@/utils/httpFun'
  import UpLoadImng from '@/components/component-block/block-uploadImg.vue'
  export default{
    components:{
        UpLoadImng:UpLoadImng
    },
     data(){
       return{
          imgList:[],
          showBlock: false,
       }
     }, 
     created(){
   
     },
     methods:{
        
        getUpload(ev){
           console.log("上传成功后的值",ev)
        },
        //关闭弹窗
        handleClose() {
            this.showBlock = false
        }
     }
  }
</script>

<style scoped lang="scss">
    .warpImg{
       width: 60px;
       height: 60px;
       border: 1px solid #A0A0A0; 
       margin-right: 10px;
       border-radius:4px;
       overflow: hidden;
       img{
         height: 100%;
       }
    }
    .UpImg{
       width: 60px;
       height: 60px;
       border: 1px solid #A0A0A0;
       border-radius:4px;
       overflow: hidden;
       position: relative;
       .btn{
         height: 100%;
         width: 100%;
         position: absolute;
         top: 0;
         left: 0;
         z-index: 8;
         display: flex;
         justify-content: space-around;
         align-items: center;
       }
       i{
         font-size:25px;
       }
       input{
         height: 100%;
         opacity: 0;
         cursor: pointer;
         position: absolute;
         z-index: 10;
       }
    }
</style>